import { useMemo } from 'react';

import { useActivityBuilderTheme } from 'approot/activity-builder/theme/activity-builder-theme';
import {
  ACTIVITIES_FONT_1_2,
  ACTIVITIES_FONT_3_4,
  ACTIVITIES_FONT_5_6,
  ACTIVITIES_FONT_K,
} from 'global/constants';
import { Field } from './response.constants';

export const useResponseBaseHeight = () => {
  const { theme } = useActivityBuilderTheme();

  const baseHeight = useMemo(() => {
    switch (theme.font.medium.size) {
      case ACTIVITIES_FONT_K:
        return 72;
      case ACTIVITIES_FONT_1_2:
        return 58;
      case ACTIVITIES_FONT_3_4:
        return 50;
      case ACTIVITIES_FONT_5_6:
        return 48;
      default:
        return 72;
    }
  }, [theme.font.medium.size]);

  return baseHeight;
};

export const useResponseRichtextSettings = (field: Field) => {
  const settings = useMemo(() => {
    return {
      placeholder: !field.isPlaceholderScaffold
        ? field.placeholder || ''
        : undefined,
      readonlyPlaceholder: field.isPlaceholderScaffold
        ? field.placeholder || ''
        : undefined,
      canChangeBlockType: false,
      canBold: false,
      canItalic: false,
      canUnderline: false,
      canAddLists: false,
      canChangeHistory: false,
      canChangeFonts: false,
      canAddLinks: false,
      canAlignText: false,
    };
  }, [field]);
  return settings;
};
